import TymberSitesRepository from "../../sites/tymberSitesRepository";

export default function makeSitesRepository() {
  return new TymberSitesRepository();
}
